/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { create } from 'zustand'

type Company = { id: number; code: string; name: string }
type User = {
  id: number
  username: string
  first_name?: string
  company?: Company
  role?: string
  is_superuser?: boolean
}

/** ------------------------------------------------------------------
 *  Chaves novas + compatibilidade com chaves antigas (legado)
 *  ----------------------------------------------------------------- */
const ACCESS_KEY = 'movatic.access'
const REFRESH_KEY = 'movatic.refresh'

// possíveis chaves legadas já usadas no projeto
const LEGACY_ACCESS_KEYS = ['access', 'auth.access', 'movatic.access']
const LEGACY_REFRESH_KEYS = ['refresh', 'auth.refresh', 'movatic.refresh']

function readFirst(keys: string[]): string | null {
  try {
    for (const k of keys) {
      const v = localStorage.getItem(k)
      if (v) return v
    }
  } catch {
    /* ignore */
  }
  return null
}

function writeToken(access?: string, refresh?: string) {
  try {
    if (access !== undefined) {
      localStorage.setItem(ACCESS_KEY, access)
      // espelha nas chaves legadas para compatibilidade
      localStorage.setItem('access', access)
      localStorage.setItem('auth.access', access)
    }
    if (refresh !== undefined) {
      localStorage.setItem(REFRESH_KEY, refresh)
      // espelha nas chaves legadas para compatibilidade
      localStorage.setItem('refresh', refresh)
      localStorage.setItem('auth.refresh', refresh)
    }
  } catch {
    /* ignore */
  }
}

function clearAllTokens() {
  try {
    const all = new Set([
      ACCESS_KEY,
      REFRESH_KEY,
      ...LEGACY_ACCESS_KEYS,
      ...LEGACY_REFRESH_KEYS,
    ])
    for (const k of all) localStorage.removeItem(k)
  } catch {
    /* ignore */
  }
}

/** ------------------------------------------------------------------ */

type TokensA = { access: string; refresh: string } // forma antiga
type TokensB = { accessToken: string; refreshToken: string } // forma nova
type AnyTokens = TokensA | TokensB

interface State {
  accessToken: string | null
  refreshToken: string | null
  user: User | null
  /** Aceita {access, refresh} OU {accessToken, refreshToken} */
  setTokens: (t: AnyTokens) => void
  setUser: (u: User | null) => void
  logout: () => void
}

/** Estado inicial: tenta novas chaves; se não, cai nas legadas */
const initialAccess = readFirst([ACCESS_KEY, ...LEGACY_ACCESS_KEYS])
const initialRefresh = readFirst([REFRESH_KEY, ...LEGACY_REFRESH_KEYS])

export const useAuthStore = create<State>((set) => ({
  accessToken: initialAccess,
  refreshToken: initialRefresh,
  user: null,

  setTokens: (t: AnyTokens) => {
    // normaliza formato
    const access =
      'accessToken' in t ? t.accessToken : 'access' in t ? t.access : ''
    const refresh =
      'refreshToken' in t ? t.refreshToken : 'refresh' in t ? t.refresh : ''

    writeToken(access, refresh)
    set({ accessToken: access, refreshToken: refresh })
  },

  setUser: (u) => set({ user: u }),

  logout: () => {
    clearAllTokens()
    set({ accessToken: null, refreshToken: null, user: null })
  },
}))
